"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeRefs = void 0;
const mergeRefs = (refs) => (value) => {
    for (const ref of refs) {
        if (typeof ref === 'function') {
            ref(value);
        }
        else if (ref !== null && ref !== undefined && 'current' in ref) {
            ref.current = value;
        }
    }
};
exports.mergeRefs = mergeRefs;
//# sourceMappingURL=mergeRefs.js.map